import { createSlice } from '@reduxjs/toolkit';
import { productsDetailById } from './productsSlice';



const initialState = {
  rawInventory:[]
};

const getProductById =(id)=>{
  let product = productsDetailById(id)
  return product

}

export const rawInventorySlice = createSlice({
  name: 'rawInventory',
  initialState,
  reducers: {
    setRawInventory: (state, { payload }) => {
    //  payload = payload.map((item)=>{
    //     let product = productsDetailById(item.id)
    //     console.log(item,product);
    //     return {...item,product}
    //   })
      
      state.rawInventory = [...payload];
    },
    
   
    clearRawInventoryState: (state) => {
      state=initialState
    }
  }
});

export const { setRawInventory, clearRawInventoryState } = rawInventorySlice.actions;

export const rawInventoryData = (state) => state.rawInventory;


export default rawInventorySlice.reducer;
